import Vue from "vue";

export const useNotify = () => Vue.prototype.$snotify;
